// extracted by mini-css-extract-plugin
export var fullWidthContent = "style-module--fullWidthContent--8b5fb";